import { useEffect, useState } from "react";
import { Megaphone } from "lucide-react";
import AdBanner, { getAdsConfig } from "@/components/AdBanner";

export default function Werbeseite() {
  const [snippets, setSnippets] = useState(null);

  useEffect(() => {
    getAdsConfig().then((cfg) => {
      setSnippets(cfg?.enabled ? cfg.werbeseite_snippets || [] : []);
    });
  }, []);

  return (
    <div className="space-y-6" data-testid="werbeseite-page">
      <div className="animate-fade-up">
        <div className="flex items-center gap-2">
          <Megaphone className="h-7 w-7 text-primary" strokeWidth={2.5} />
          <h1 className="font-heading font-black text-3xl sm:text-4xl tracking-tight">Werbeseite</h1>
        </div>
        <p className="text-muted-foreground font-medium mt-1">
          Diese Seite finanziert DevPath durch Werbung.
        </p>
      </div>

      {snippets === null ? (
        <div className="font-bold">Lädt...</div>
      ) : snippets.length === 0 ? (
        <p className="text-muted-foreground font-medium">Aktuell ist hier keine Werbung hinterlegt.</p>
      ) : (
        <div className="flex flex-col items-center gap-6">
          {snippets.map((s, i) => (
            <AdBanner key={i} snippet={s} className="nb-card p-4" />
          ))}
        </div>
      )}
    </div>
  );
}
